import { useEffect } from 'react';

// A direct fragment URL can load before React has rendered its destination.
export default function usePageAnchor(hash) {
  useEffect(() => {
    if (!hash) return;
    const frame = window.requestAnimationFrame(() => {
      const target = document.getElementById(hash.replace(/^#/, ''));
      if (target) target.scrollIntoView({ block: 'start' });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [hash]);
}
